/* Warenkorb-Rueckmeldung — gehoert zu snippets/cart-feedback.liquid */
(function () {
  if (window.__yhCartFeedback) return;
  window.__yhCartFeedback = true;

  /* Wird vom Snippet gesetzt, bevor diese Datei laeuft. */
  var CFG = window.YH_CART_FEEDBACK || {};
  var CART_URL = CFG.cartUrl || '/cart';
  var LABEL_ADDED = CFG.labelAdded || 'In den Warenkorb gelegt';

  var lastAnnounce = 0;

  /* Zuletzt geklickter Quick-Add-Button: Startpunkt fuer den Flug
     zum Warenkorb. Wird im Capture-Modus gesetzt, damit er vor dem
     eigentlichen Klick-Handler in custom.js bekannt ist. */
  var lastQuickAdd = null;
  var lastQuickAddAt = 0;
  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('.quick-add-btn') : null;
    if (btn) {
      lastQuickAdd = btn;
      lastQuickAddAt = new Date().getTime();
    }
  }, true);

  /* Zaehlt als Treffer: /cart/add und /cart/add.js, auch mit
     Sprachpraefix wie /de-ch/cart/add.js. */
  function isAddRequest(url) {
    try {
      return /\/cart\/add(\.js)?(\?|$)/.test(String(url).split('#')[0]);
    } catch (e) {
      return false;
    }
  }

  /* ---------- 1. fetch (Sticky-Leiste, Quick-Add, Apps) ---------- */
  var originalFetch = window.fetch;
  if (typeof originalFetch === 'function') {
    window.fetch = function (input, init) {
      var url = input && input.url ? input.url : input;
      var promise = originalFetch.apply(this, arguments);
      if (isAddRequest(url)) {
        promise.then(function (response) {
          if (response && response.ok) announce();
        }).catch(function () {});
      }
      return promise;
    };
  }

  /* ---------- 2. XHR (jQuery-Weg des Themes) ---------- */
  var xhrOpen = XMLHttpRequest.prototype.open;
  var xhrSend = XMLHttpRequest.prototype.send;

  XMLHttpRequest.prototype.open = function (method, url) {
    this.__yhIsAdd = isAddRequest(url);
    return xhrOpen.apply(this, arguments);
  };

  XMLHttpRequest.prototype.send = function () {
    if (this.__yhIsAdd) {
      this.addEventListener('load', function () {
        if (this.status >= 200 && this.status < 300) announce();
      });
    }
    return xhrSend.apply(this, arguments);
  };

  /* ---------- 3. Formular-Absenden abfangen ---------- */
  /*
    Auf dem Shop wird der Ajax-Warenkorb des Themes gar nicht
    gestartet: snippets/ajax-cart.liquid setzt die Klasse
    "jsAjaxCart" nur, wenn der mobile Header ihn rendert. Der
    Container kommt hier aber aus header__action-icons.liquid,
    also ohne diese Klasse — und der Section-Loader in app.js
    startet nur, was so markiert ist.

    Folge: der Klick-Handler auf .ajax-submit ist nie gebunden,
    das Formular geht als normales POST raus und Shopify leitet
    auf /cart weiter. Genau der Sprung, der hier weg soll.

    Deshalb faengt dieser Handler das Absenden selbst ab. Sollte
    der Theme-Handler doch einmal aktiv sein, ruft er schon beim
    Klick preventDefault auf — dann entsteht gar kein
    submit-Ereignis und dieser Code laeuft nicht. Ein doppeltes
    Hinzufuegen ist damit ausgeschlossen.
  */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || form.nodeName !== 'FORM') return;
    if (!isAddRequest(form.getAttribute('action') || '')) return;

    e.preventDefault();
    submitAdd(form);
  });

  function submitAdd(form) {
    var btn = form.querySelector('[data-add-to-cart-trigger]')
      || form.querySelector('button[type="submit"], input[type="submit"]');

    var warning = form.querySelector('.cart-warning');
    if (warning) warning.innerHTML = '';

    setPending(btn);

    /* Die action des Formulars statt eines festen Pfads — so
       bleibt ein Sprachpraefix wie /de-ch/ erhalten. */
    var action = form.getAttribute('action') || CART_URL + '/add';
    var url = /\.js$/.test(action) ? action : action + '.js';

    var request = typeof originalFetch === 'function' ? originalFetch : window.fetch;

    request(url, {
      method: 'POST',
      body: new FormData(form),
      credentials: 'same-origin',
      headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json' }
    })
      .then(function (r) {
        return r.json().then(function (data) { return { ok: r.ok, data: data }; });
      })
      .then(function (res) {
        if (!res.ok) {
          showFormError(form, btn, res.data);
          return;
        }
        showSuccess(btn);
        announce();
      })
      .catch(function () {
        /* Lieber die normale Seite als gar keine Rueckmeldung.
           form.submit() loest kein submit-Ereignis aus, es kann
           also keine Schleife entstehen. */
        form.submit();
      });
  }

  /* ---------- Button-Zustaende (Optik wie im Theme) ---------- */
  function setPending(btn) {
    if (!btn) return;
    btn.setAttribute('disabled', 'disabled');
    btn.classList.add('disabled');
    Array.prototype.forEach.call(btn.querySelectorAll('span'), function (s) {
      s.classList.remove('fadeInDown');
      s.classList.add('animated', 'zoomOut');
    });
  }

  function showSuccess(btn) {
    if (!btn) return;

    /* Der Haken liegt absolut zentriert im Button. Er wird
       sichtbar, waehrend die Beschriftung weggezoomt ist. */
    var check = btn.querySelector('.checkmark');
    if (check) check.classList.add('checkmark-active');

    window.setTimeout(function () {
      btn.removeAttribute('disabled');
      btn.classList.remove('disabled');
      if (check) check.classList.remove('checkmark-active');

      Array.prototype.forEach.call(btn.querySelectorAll('.text, .icon'), function (s) {
        s.classList.remove('zoomOut');
        s.classList.add('fadeInDown');
      });
    }, 1000);
  }

  function showFormError(form, btn, data) {
    if (btn) {
      btn.removeAttribute('disabled');
      btn.classList.remove('disabled');
      Array.prototype.forEach.call(btn.querySelectorAll('span'), function (s) {
        s.classList.remove('zoomOut');
        s.classList.add('zoomIn');
      });
    }

    var warning = form.querySelector('.cart-warning');
    var message = data && data.description;
    if (!warning || !message) return;

    warning.innerHTML = '<p class="cart-warning__message animated bounceIn"></p>';
    warning.querySelector('.cart-warning__message').textContent = message;
  }

  /* ---------- Auswertung ---------- */
  function announce() {
    /* Die Sticky-Leiste faellt bei Varianten-Produkten auf einen
       Klick des Original-Buttons zurueck. Dann laufen fetch- und
       XHR-Weg fuer denselben Klick — die Sperre verhindert, dass
       die Bestaetigung doppelt aufblitzt. */
    var now = new Date().getTime();
    if (now - lastAnnounce < 600) return;
    lastAnnounce = now;

    var load = typeof originalFetch === 'function' ? originalFetch : window.fetch;
    load(CART_URL + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        updateCount(cart.item_count);
        speak();
        flyToCart();
      })
      .catch(function () {});
  }

  function updateCount(count) {
    var nodes = document.querySelectorAll(
      '[data-bind="itemCount"], .header-cart__count, [data-cart-count], [data-bnav-cart-count]'
    );

    Array.prototype.forEach.call(nodes, function (el) {
      el.textContent = count;
      if (el.hasAttribute('data-count')) el.setAttribute('data-count', count);

      el.classList.remove('yh-cart-bump');
      /* Erzwingt einen Reflow. Ohne ihn erkennt der Browser den
         Klassenwechsel als Nicht-Aenderung und die Animation
         startet beim zweiten Artikel nicht erneut. */
      void el.offsetWidth;
      el.classList.add('yh-cart-bump');
    });

    var wrappers = document.querySelectorAll('.header-cart, [data-ajax-cart-trigger]');
    Array.prototype.forEach.call(wrappers, function (w) {
      if (count > 0) w.classList.add('has-cart-count');
      else w.classList.remove('has-cart-count');
    });
  }

  /* ---------- Flug zum Warenkorb ---------- */
  /*
    Ein kleiner Punkt loest sich vom Quick-Add-Button und fliegt zur
    Tasche im Header; dort wackelt die Tasche kurz. Nur wenn der Add
    von einem Quick-Add-Button kam (sonst gibt es keinen sinnvollen
    Startpunkt) und nur, wenn die Tasche sichtbar ist.

    Die Bahn wird als CSS-Variablen an den Punkt gehaengt - die
    Animation selbst laeuft in cart-feedback.css und animiert nur
    transform/opacity.
  */
  function flyToCart() {
    var now = new Date().getTime();
    if (!lastQuickAdd || now - lastQuickAddAt > 4000) return;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var target = visibleCartIcon();
    if (!target) return;

    var from = lastQuickAdd.getBoundingClientRect();
    var to = target.getBoundingClientRect();
    if (!from.width || !to.width) return;

    var size = 14;
    var x0 = from.left + from.width / 2 - size / 2;
    var y0 = from.top + from.height / 2 - size / 2;
    var x1 = to.left + to.width / 2 - size / 2;
    var y1 = to.top + to.height / 2 - size / 2;
    /* Zwischenpunkt etwas oberhalb der Geraden - ergibt den Bogen. */
    var xm = x0 + (x1 - x0) * 0.45;
    var ym = Math.min(y0, y1) - 60;

    var dot = document.createElement('span');
    dot.className = 'yh-fly-dot';
    dot.setAttribute('aria-hidden', 'true');
    dot.style.setProperty('--yh-x0', x0 + 'px');
    dot.style.setProperty('--yh-y0', y0 + 'px');
    dot.style.setProperty('--yh-xm', xm + 'px');
    dot.style.setProperty('--yh-ym', ym + 'px');
    dot.style.setProperty('--yh-x1', x1 + 'px');
    dot.style.setProperty('--yh-y1', y1 + 'px');
    document.body.appendChild(dot);

    var cleaned = false;
    function done() {
      if (cleaned) return;
      cleaned = true;
      if (dot.parentNode) dot.parentNode.removeChild(dot);
      target.classList.remove('yh-cart-catch');
      void target.offsetWidth;
      target.classList.add('yh-cart-catch');
    }
    dot.addEventListener('animationend', done);
    /* Sicherheitsnetz, falls animationend nicht feuert. */
    window.setTimeout(done, 900);
  }

  /* Die Tasche, die gerade tatsaechlich sichtbar ist - der Header
     rendert je nach Layout mehrere (Desktop, Mobile, Sticky). */
  function visibleCartIcon() {
    var icons = document.querySelectorAll('.header-cart__icon');
    for (var i = 0; i < icons.length; i++) {
      var r = icons[i].getBoundingClientRect();
      if (r.width > 0 && r.height > 0 && r.bottom > 0 && r.top < window.innerHeight) return icons[i];
    }
    return null;
  }

  /* ---------- Unsichtbare Ansage fuer Screenreader ---------- */
  function speak() {
    var el = document.getElementById('yh-cart-sr');
    if (!el) {
      el = document.createElement('div');
      el.id = 'yh-cart-sr';
      el.className = 'yh-cart-sr';
      el.setAttribute('role', 'status');
      el.setAttribute('aria-live', 'polite');
      document.body.appendChild(el);
    }
    /* Erst leeren, dann setzen: aria-live meldet nur Aenderungen,
       sonst bliebe der zweite Artikel stumm. */
    el.textContent = '';
    window.setTimeout(function () { el.textContent = LABEL_ADDED; }, 60);
  }
})();
